import { string } from "yup"

export default string().url("Invalid url scheme").required("Required")
